require('./countrySelector.scss');

// @vendor
const React = require('react');
const { Component } = require('react');
import PropTypes from 'prop-types';

// @core
const { formatText, hasTranslation } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');

// @components
import OKSelect from 'components/commons/OKSelect/OKSelect';

// @constants
const COUNTRY_CODES = require('commonsConstants/countryCodes')


class CountrySelector extends Component {
    render() {
        const { onHandleChange, selectedCountry } = this.props
        const countryOptions = Object
            .keys(COUNTRY_CODES)
            .map(cc => {
                const countryCode = COUNTRY_CODES[cc];
                const countryLabel = hasTranslation(`countries-${countryCode}`) ? toCamelCase(formatText(`countries-${countryCode}`)): countryCode;
                return {
                    label: countryLabel, value: countryCode
                }
            });

        return (
            <div className="ok-select-country">
                <OKSelect
                    onChange={onHandleChange}
                    options={countryOptions}
                    value={selectedCountry}
                    {...this.props}
                />
            </div>

        );
    }
}

module.exports = CountrySelector;

CountrySelector.defaultProps = {
    selectedCountry: COUNTRY_CODES.COUNTRY_CODE_ES
}

CountrySelector.propTypes = {
    onHandleChange: PropTypes.func,
    selectedCountry: PropTypes.string
};
